import { Box, Container, Typography } from '@mui/material';

/** A form's column: as wide as its fields, centred on the page. */
const NARROW_WIDTH = 440;

/**
 * The frame of an admin page other than the calendar: a readable width, a title and a line saying
 * what the page is for. `narrow` makes it a single centred column, for a form; the calendar keeps
 * its own full-width sections.
 */
const AdminPage = ({ title, subtitle, narrow = false, children }) => {
  const header = (
    <Box sx={{ mb: 3, textAlign: narrow ? 'center' : 'left' }}>
      <Typography component="h1" variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );

  if (narrow) {
    return (
      <Box sx={{ maxWidth: NARROW_WIDTH, mx: 'auto', px: { xs: 2, sm: 0 }, py: { xs: 3, md: 5 }, boxSizing: 'content-box' }}>
        {header}
        {children}
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
      {header}
      {children}
    </Container>
  );
};

export default AdminPage;
